import { render, staticRenderFns } from "./FeedManagerView.vue?vue&type=template&id=7c635bac&scoped=true&"
import script from "./FeedManagerView.vue?vue&type=script&lang=js&"
export * from "./FeedManagerView.vue?vue&type=script&lang=js&"
import style0 from "./FeedManagerView.vue?vue&type=style&index=0&id=7c635bac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c635bac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/harness/feed-manager-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c635bac')) {
      api.createRecord('7c635bac', component.options)
    } else {
      api.reload('7c635bac', component.options)
    }
    module.hot.accept("./FeedManagerView.vue?vue&type=template&id=7c635bac&scoped=true&", function () {
      api.rerender('7c635bac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/FeedManagerView.vue"
export default component.exports